import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAppointmentDocumentSignature(taskId: string, employeeId: string) {
  try {
    const response = await apiGet('core', 'documents-signed/appointment-documents', {
      queryParams: {
        task_id: taskId,
        employeeId,
      }
    });
    return response?.content;
  } catch (e) { }
}

export async function postAppointmentDocumentSignature(taskId: string, employeeId: string) {
  try {
    const response = await apiPost('core', 'documents-signed/appointment-documents/', {
      task_id: taskId,
      employee_id: employeeId,
    });
    return response;
  } catch (e) { }
}